/* globals toastr */
import i18n from './i18n';

const template = (title, message) => `<h5>${title}</h5><span>${message}</span>`;

function showNotificationError(title, message) {
  if (typeof toastr !== 'undefined') {
    toastr.error(template(title, message));
  }
}

function showNotificationWarning(title, message) {
  if (typeof toastr !== 'undefined') {
    toastr.warning(template(title, message));
  }
}

function showNotificationSuccess(title, message) {
  if (typeof toastr !== 'undefined') {
    toastr.success(template(title, message));
  }
}

function showErrorFromRequest(err, defaultErrorKey) {
  console.log('*ERR', err);
  let error = i18n.__(defaultErrorKey);
  if (err && err.responseJSON) {
    if (err?.responseJSON?.err?.response?.data?.error) {
      error = i18n.__('ERROR_OPERATION_NOT_ALLOWED_IN_TEST');
    } else if (err.responseJSON.message || err.responseJSON.error) {
      if (err.responseJSON.message === 'ERROR_OPERATION_NOT_ALLOWED_IN_TEST') {
        error = i18n.__('ERROR_OPERATION_NOT_ALLOWED_IN_TEST');
      } else {
        error = err.responseJSON.message || i18n.__(err.responseJSON.error);
      }
    }
  } else if (err && err.response && err.response.data) {
    if (err.response.data.error || err.response.data.message) {
      error = err.response.data.error
        ? i18n.__(err.response.data.error)
        : err.response.data.message;
    }
  }
  showNotificationError(i18n.__('error'), error);
}

function showErrorFromStripe(err, defaultErrorKey) {
  console.log('*** showErrorFromStripe:().err: ', err);
  let error = i18n.__(defaultErrorKey);
  if (err) {
    if (typeof err === 'string') {
      error = i18n.__(err);
    } else if (err.error) {
      if (err.error.message) {
        error = err.error.message || i18n.__(err.error.error);
      }
    }
  }
  showNotificationError(i18n.__('error'), error);
}

export default {
  showErrorFromStripe,
  showErrorFromRequest,
  showNotificationError,
  showNotificationWarning,
  showNotificationSuccess,
};
